import {RadioGroupRoot, RadioGroupContent} from './components/radio-group-root';
import {RadioGroupItem} from './components/radio-group-item';

export const RadioGroup = {
	Root: RadioGroupRoot,
	Content: RadioGroupContent,
	Item: RadioGroupItem,
};
